interface IconProps {
  name: 'search' | 'myths' | 'filter' | 'home' | 'share' | 'link' | 'image' | 'privacy' | 'close' | 'arrow-left' | 'arrow-right' | 'spark' | 'book' | 'chevron' | 'play' | 'pause' | 'skip-back' | 'skip-forward' | 'restart' | 'list' | 'focus' | 'audio'
  size?: number
}

export function Icon({ name, size = 20 }: IconProps) {
  const paths: Record<IconProps['name'], React.ReactNode> = {
    search: <><circle cx="11" cy="11" r="6" /><path d="m16 16 4 4" /></>,
    myths: <><path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H11v17H8.5A3.5 3.5 0 0 0 5 22Z" /><path d="M19 5.5A3.5 3.5 0 0 0 15.5 2H13v17h2.5A3.5 3.5 0 0 1 19 22Z" /></>,
    filter: <><path d="M4 6h16M7 12h10M10 18h4" /></>,
    home: <><path d="m4 11 8-7 8 7" /><path d="M6 10v10h12V10M10 20v-6h4v6" /></>,
    share: <><circle cx="18" cy="5" r="2.5" /><circle cx="6" cy="12" r="2.5" /><circle cx="18" cy="19" r="2.5" /><path d="m8.2 10.8 7.6-4.6M8.2 13.2l7.6 4.6" /></>,
    link: <><path d="M10 13a5 5 0 0 0 7.1.1l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1" /><path d="M14 11a5 5 0 0 0-7.1-.1l-2 2A5 5 0 0 0 12 20l1.1-1.1" /></>,
    image: <><rect x="3" y="4" width="18" height="16" rx="1" /><circle cx="9" cy="9" r="2" /><path d="m4 17 5-5 4 4 2-2 5 5" /></>,
    privacy: <><path d="M12 3 5 6v5c0 4.7 2.8 8 7 10 4.2-2 7-5.3 7-10V6Z" /><path d="M9.5 12 11 13.5l3.5-4" /></>,
    close: <path d="M6 6l12 12M18 6 6 18" />,
    'arrow-left': <path d="m15 18-6-6 6-6" />,
    'arrow-right': <path d="m9 18 6-6-6-6" />,
    spark: <><path d="m12 3 1.4 5.6L19 10l-5.6 1.4L12 17l-1.4-5.6L5 10l5.6-1.4Z" /><path d="m19 16 .6 2.4L22 19l-2.4.6L19 22l-.6-2.4L16 19l2.4-.6Z" /></>,
    book: <><path d="M4 4h6a2 2 0 0 1 2 2v14a2 2 0 0 0-2-2H4Z" /><path d="M20 4h-6a2 2 0 0 0-2 2v14a2 2 0 0 1 2-2h6Z" /></>,
    chevron: <path d="m9 18 6-6-6-6" />,
    play: <path d="m8 5 11 7-11 7Z" />,
    pause: <><path d="M9 5v14" /><path d="M15 5v14" /></>,
    'skip-back': <><path d="M5 5v14" /><path d="m18 6-9 6 9 6Z" /></>,
    'skip-forward': <><path d="M19 5v14" /><path d="m6 6 9 6-9 6Z" /></>,
    restart: <><path d="M4 12a8 8 0 1 0 2.3-5.7L4 8.6" /><path d="M4 4v4.6h4.6" /></>,
    list: <><path d="M8 6h12M8 12h12M8 18h12" /><path d="M4 6h.01M4 12h.01M4 18h.01" /></>,
    focus: <><circle cx="12" cy="12" r="4" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3" /></>,
    audio: <><path d="M5 9v6h4l5 4V5L9 9Z" /><path d="M17 9.5a4 4 0 0 1 0 5" /><path d="M19.5 7a7 7 0 0 1 0 10" /></>,
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name]}
    </svg>
  )
}
